
import { CarpassService } from "@/services/carpass-service";
import { MainActivity } from "@/utils/carpass/main-activity";
import { ObservationDescription } from "@/utils/carpass/observation-description";
import { ObservationDescriptionActivity } from "@/utils/carpass/observation-description-activity";
import { SubActivity } from "@/utils/carpass/sub-activity";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			activities: [] as MainActivity[],
			selectedMainActivity: null as null | MainActivity,
			selectedSubActivity: null as null | SubActivity
		};
	},
	props: {
		value: Boolean,
		result: {
			type: Object as ()=>ObservationDescription,
			required: true
		}
	},
	computed: {
		mainActivityItems():ISelectItem<MainActivity>[]{
			return this.activities.map(a=>{
				return {
					text: a.getTranslation(),
					value: a
				} as ISelectItem<MainActivity>;
			});
		},
		subActivityItems():ISelectItem<SubActivity>[]{
			if (!this.selectedMainActivity) return [];
			return this.selectedMainActivity.subActivities.map(a=>{
				return {
					text: a.getTranslation(),
					value: a
				} as ISelectItem<SubActivity>;
			});
		},
		isValid():boolean{
			if (!this.selectedMainActivity) return false;
			if (!this.selectedSubActivity) return false;
			return true;
		}
	},
	watch: {
		selectedMainActivity(){
			if (!this.selectedMainActivity) {
				this.selectedSubActivity = null;
				return;
			}
			this.selectedSubActivity = this.selectedMainActivity.subActivities[0];
		},
		value(){
			this.selectedMainActivity = this.activities[0];
		},
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		confirm(){
			if (!this.isValid)return;
			if (!this.selectedMainActivity) return;
			if (!this.selectedSubActivity) return;
			let a = new ObservationDescriptionActivity();
			a.mainActivity = this.selectedMainActivity.mainActivity;
			a.subActivity = this.selectedSubActivity.subActivity;
			this.result.activities.push(a);
			this.$emit("close");
		}
	},
	async created(){
		this.activities = await CarpassService.getActivities();
		this.selectedMainActivity = this.activities[0];
	},
	i18nEx: {
		componentPrefix: "components.cars"
	}
});
